import angular from 'angular';
import moment from 'moment';
import DocumentService from '@/shared/services/DocumentService';

const mapScheduleLine = line => ({
  ...line,
  invoiceTextType:
    line.invoicingType === 0
      ? 3 // RegistrationBased
      : line.invoicingType === 1
      ? 0 // FixedAmount
      : line.fixed
      ? 1 // Advance
      : 2, // Settlement
  isHistory: !!line.processed || !!line.isRemoved,
  isCurrentSchedule: !line.isRemoved || !line.processed,
});

angular
  .module('cloudX')
  .controller('InvoiceStreamScheduleDialogCtrl', [
    'resourceFactorySvc',
    'dialogsSvc',
    'flySvc',
    '$element',
    'close',
    'stream',
    'appUrls',
    'checkSecurity',
    '$http',
    '$timeout',
    invoiceStreamScheduleDialogCtrl,
  ]);

function invoiceStreamScheduleDialogCtrl(
  resourceFactorySvc,
  dialogsSvc,
  flySvc,
  $element,
  close,
  stream,
  appUrls,
  checkSecurity,
  $http,
  $timeout,
) {
  var vm = this;
  vm.lines = [];
  vm.showHistory = false;
  vm.historyEnabled = false;
  vm.showTaskInfo = false;
  vm.showReferenceYear = false;
  vm.taskDetail = null;
  vm.invoicingType = (
    stream.schedule || {
      invoicingType: -1,
    }
  ).invoicingType;
  vm.invoiceTexts = null;
  var hasChanges = false;
  vm.streamAmount = stream.amount;
  vm.scheduleId = (stream.schedule || {}).id;

  vm.showInvoiceTextInfo = false;
  vm.hasLinesFromOlderSchedules = false;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };

  var resource = resourceFactorySvc.get('invoiceStream');
  resource.schedules(
    {
      id: stream.id,
    },
    function(data) {
      vm.lines = data.map(mapScheduleLine);
      vm.historyEnabled = vm.lines.some(function(line) {
        return line.processed === true || line.isRemoved;
      });
      vm.showHistory =
        vm.lines.some(
          line =>
            !line.isRemoved &&
            line.processed &&
            moment(line.invoiceCreationDate).isAfter(moment().utc()),
        ) || vm.lines.every(line => line.processed || line.isRemoved);
      vm.hasLinesFromOlderSchedules = vm.lines.some(line => !line.isCurrentSchedule);

      vm.showTaskInfo = vm.lines.some(x => x.taskId);
      vm.showReferenceYear = vm.lines.some(x => x.useReferenceYear);
    },
    showError,
  );

  vm.showInvoice = function(documentPdfId) {
    if (!documentPdfId) {
      flySvc.error('msgCouldNotFindInvoicePdf');
      return;
    }
    DocumentService.open(documentPdfId);
  };

  vm.save = function() {
    close(hasChanges, 500);
    $element.modal('hide');
  };

  vm.cancel = function() {
    close(hasChanges, 500);
  };

  vm.loadInvoiceTexts = function() {
    if (vm.invoiceTexts != null) return null;
    return resourceFactorySvc.get('invoiceText').get(
      {},
      function(data) {
        vm.invoiceTexts = data;
      },
      showError,
    ).$promise;
  };
  vm.updateLine = function(line, field, data, ignoreDateCheck = false) {
    //Validation error
    if (typeof data === 'undefined') return '';
    if (angular.equals(line[field], data)) return false;
    if (field === 'invoiceText' && !!vm.scheduleId && checkSecurity('Settings:u')) {
      vm.showInvoiceTextInfo = true;
    }

    if (!ignoreDateCheck) {
      if (
        (field === 'date' && Math.abs(moment(data).diff(moment(line.date), 'months')) >= 1) ||
        (field === 'invoiceCreationDate' &&
          Math.abs(moment(data).diff(moment(line.invoiceCreationDate), 'months')) >= 1)
      ) {
        return dialogsSvc.showYesNo('comfirmTitle', 'msgConfirmChangeScheduleDateMessage').then(
          function() {
            return vm.updateLine(line, field, data, true);
          },
          function() {
            return false;
          },
        );
      }
    }

    var model = angular.copy(line);
    var dateChanged = false;
    if (field === 'date' && moment(data).isAfter(moment(line.invoiceCreationDate))) {
      model.invoiceCreationDate = moment(data)
        .clone()
        .add(1, 'day')
        .toDate();
      dateChanged = true;
    } else if (field === 'invoiceCreationDate' && moment(data).isBefore(moment(line.date))) {
      model.date = moment(data)
        .clone()
        .add(-1, 'day')
        .toDate();
      dateChanged = true;
    }
    model[field] = data;
    return resource.updateSchedule(model).$promise.then(function(response) {
      if (response) {
        hasChanges = true;
        angular.extend(line, response);
        if (dateChanged) {
          flySvc.message(
            `msgInvoiceScheduleDateChanged${field === 'date' ? 'InvoiceCreationDate' : 'Date'}`,
          );
        }
      }
      return false;
    }, showError);
  };

  vm.deleteLine = function(id) {
    dialogsSvc
      .showYesNo('msgConfirmDeleteTitle', 'msgDeleteInvoiceStreamScheduleLine')
      .then(function() {
        resource
          .deleteSchedule({
            id: id,
          })
          .$promise.then(function(response) {
            if (response) {
              hasChanges = true;
              flySvc.success('msgInvoiceStreamScheduleLineDeleted');
              if (vm.lines) {
                for (var t = 0; t < vm.lines.length; t++) {
                  if (vm.lines[t].id === id) {
                    vm.lines[t].isRemoved = true;
                    vm.lines[t].isHistory = true;
                    vm.historyEnabled = true;
                    //vm.lines.splice(t, 1);
                    break;
                  }
                }
              }
            }
            return false;
          }, showError);
      });
  };

  vm.reprocessLine = function(line) {
    if (!line || line.invoice || line.isRemoved || !line.processed || !line.id) return;
    line.saving = true;
    return $http
      .post(`${appUrls.api}/api/InvoiceStream/ReprocessSchedule`, null, {
        params: { id: line.id },
      })
      .then(({ data = null }) => {
        if (data) {
          angular.extend(line, mapScheduleLine(data));
          hasChanges = true;
        }
      }, showError)
      .finally(() => {
        line.saving = false;
      });
  };

  vm.openTask = function(taskId) {
    if (!taskId) return;
    vm.taskDetail = { id: taskId };
  };
  vm.closeTaskDetail = function() {
    $timeout(() => {
      vm.taskDetail = null;
    }, 0);
  };
}
